interface TempSliderProps {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

export default function TempSlider({
  value,
  onChange,
  min = 30,
  max = 37,
  step = 0.1,
}: TempSliderProps) {
  const pct = ((value - min) / (max - min)) * 100;

  // Categoría visual según rango
  let category = '';
  let categoryColor = '';
  if (value < 32) {
    category = 'Piel fría · evaporación lenta · admite intensos';
    categoryColor = '#3A6B7C';
  } else if (value <= 34) {
    category = 'Piel templada · versatilidad total';
    categoryColor = '#A8C77A';
  } else {
    category = 'Piel cálida · evaporación rápida · necesita fijadores potentes';
    categoryColor = '#D2691E';
  }

  return (
    <div className="space-y-4">
      {/* Display grande del valor */}
      <div className="flex items-baseline justify-center gap-2">
        <span className="display text-7xl text-elixir-gold">{value.toFixed(1)}</span>
        <span className="text-2xl text-elixir-cream/60">°C</span>
      </div>

      {/* Slider */}
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className="w-full h-3 rounded-full appearance-none cursor-pointer"
        style={{
          background: `linear-gradient(90deg,
            #3A6B7C 0%, #3A6B7C ${(((32 - min) / (max - min)) * 100)}%,
            #A8C77A ${(((32 - min) / (max - min)) * 100)}%, #A8C77A ${(((34 - min) / (max - min)) * 100)}%,
            #D2691E ${(((34 - min) / (max - min)) * 100)}%, #D2691E 100%)`,
        }}
      />

      {/* Marcas de escala */}
      <div className="flex justify-between text-xs text-elixir-cream/50 px-1">
        <span>30°</span>
        <span>32°</span>
        <span>34°</span>
        <span>37°</span>
      </div>

      {/* Categoría dinámica */}
      <div
        className="text-center text-sm py-3 px-4 rounded-xl2 border"
        style={{ borderColor: categoryColor, color: categoryColor }}
      >
        {category}
      </div>

      {/* Asegura que el thumb del slider sea grande para tablet */}
      <style>{`
        input[type="range"]::-webkit-slider-thumb {
          appearance: none;
          width: 28px; height: 28px; border-radius: 50%;
          background: #C9A961; border: 3px solid #0B0B0B;
          box-shadow: 0 2px 8px rgba(0,0,0,0.5);
          cursor: pointer;
        }
        input[type="range"]::-moz-range-thumb {
          width: 28px; height: 28px; border-radius: 50%;
          background: #C9A961; border: 3px solid #0B0B0B;
          cursor: pointer;
        }
        /* Discreta marca de progreso al usar el slider */
        input[type="range"]:focus { outline: none; }
        /* Posición del valor sobre el thumb (overlay sobre slider) */
      `}</style>

      {/* indicador opcional sobre la posición del thumb */}
      <div className="relative h-0">
        <div
          className="absolute -top-12 -translate-x-1/2 px-2 py-1 rounded text-xs bg-elixir-gold text-elixir-black opacity-0 transition-opacity"
          style={{ left: `${pct}%` }}
        />
      </div>
    </div>
  );
}
